<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <v-app-bar app clipped-left dense color="appbar">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-img max-height="32" max-width="100" src="@/assets/ventive-logo-black_32pxhigh.png"></v-img>

    </v-app-bar>

    <v-navigation-drawer v-model="drawer" clipped app temporary>
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar v-if="avatar">
            <v-img style="width: 32px; height: 32px" :src="avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-avatar v-else>
            <v-icon>mdi-face</v-icon>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="title">{{userinfo.username}}</v-list-item-title>
            <v-list-item-subtitle>{{userinfo.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title @click.stop="logout">Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

    </v-navigation-drawer>

    <!-- Navigation Drawer -->

    <!-- Sizes your content based upon application components -->
    <v-main>
      <router-view class="pa-2" @authenticated="setAuthenticated" />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Layout from './Layout.vue';
import axios from 'axios';
import { carnego_theme } from '@/plugins/vuetify';

import { ICarnegoUser } from '../main';

@Component({
  components: {},
})
export default class SimpleLayout extends Layout {

  public drawer: any = false;

  public created() {
    this.theme = carnego_theme;
  }

  public closeDrawer(): void {
    this.drawer = false;
  }
}
</script>

<style lang="less">
</style>
